// Generated by scripts/sync-theme-assets.mjs from assets/garden-cache.js.
// Do not edit this file directly.

(function () {
  "use strict";

  if (window.MrMapleGardenCache) {
    return;
  }

  const cacheDebugParams = new URLSearchParams(window.location.search);
  const gardenCacheDebugEnabled =
    window.__GARDEN_DEBUG === true ||
    window.__GARDEN_CACHE_DEBUG === true ||
    cacheDebugParams.has("gardenDebug") ||
    cacheDebugParams.has("gardenCacheDebug");

  function debugWarn(message, details) {
    if (!gardenCacheDebugEnabled) {
      return;
    }

    if (typeof details === "undefined") {
      console.warn(message);
      return;
    }

    console.warn(message, details);
  }

  const DAY_MS = 24 * 60 * 60 * 1000;
  const DEFAULT_TTLS = {
    profile: 5 * 60 * 1000,
    tiers: 60 * 1000,
    achievements: 60 * 1000,
    collections: 15 * 60 * 1000,
    items: 60 * 1000,
    lists: 60 * 1000,
    notifications: 60 * 1000,
    recommendations: 15 * 60 * 1000,
    "garden-collections": 15 * 60 * 1000,
  };
  const DEFAULT_PERSIST_TTLS = {
    profile: DAY_MS,
    profileStats: DAY_MS,
    tiers: DAY_MS,
    achievements: DAY_MS,
    collections: 7 * DAY_MS,
    items: DAY_MS,
    lists: DAY_MS,
    notifications: DAY_MS,
    recommendations: DAY_MS,
  };
  const PREFIX_TTLS = [
    ["notifications-detail:", 60 * 1000],
    ["notifications-search:", 60 * 1000],
    ["share-settings:", 60 * 60 * 1000],
    ["wishlist:status:", 30 * 1000],
    ["wishlist:lists:", 60 * 1000],
    ["wishlist:product:", 15 * 60 * 1000],
    ["wishlist:recommendations:", 15 * 60 * 1000],
    ["wishlist:product-availability:", 30 * 1000],
    ["image:", 14 * DAY_MS],
  ];
  const DEFAULT_POLICIES = {
    profile: {
      domain: "profile",
      revisionDomain: "profile",
      freshForMs: DEFAULT_TTLS.profile,
      persistForMs: DEFAULT_PERSIST_TTLS.profile,
      tags: ["profile"],
    },
    profileStats: {
      domain: "profileStats",
      revisionDomain: "profileStats",
      freshForMs: 60 * 1000,
      persistForMs: DEFAULT_PERSIST_TTLS.profileStats,
      tags: ["profileStats", "tiers", "achievements"],
    },
    tiers: {
      domain: "items",
      revisionDomain: "items",
      freshForMs: DEFAULT_TTLS.tiers,
      persistForMs: DEFAULT_PERSIST_TTLS.tiers,
      tags: ["items", "tiers", "rank"],
    },
    rank: {
      domain: "items",
      revisionDomain: "items",
      freshForMs: DEFAULT_TTLS.tiers,
      persistForMs: DEFAULT_PERSIST_TTLS.tiers,
      tags: ["items", "tiers", "rank"],
    },
    achievements: {
      domain: "profileStats",
      revisionDomain: "profileStats",
      freshForMs: DEFAULT_TTLS.achievements,
      persistForMs: DEFAULT_PERSIST_TTLS.achievements,
      tags: ["profileStats", "achievements"],
    },
    lists: {
      domain: "lists",
      revisionDomain: "lists",
      freshForMs: DEFAULT_TTLS.lists,
      persistForMs: DEFAULT_PERSIST_TTLS.lists,
      tags: ["lists", "wishlist"],
    },
    items: {
      domain: "items",
      revisionDomain: "items",
      freshForMs: DEFAULT_TTLS.items,
      persistForMs: DEFAULT_PERSIST_TTLS.items,
      tags: ["items"],
    },
    collections: {
      domain: "collections",
      revisionDomain: "collections",
      freshForMs: DEFAULT_TTLS.collections,
      persistForMs: DEFAULT_PERSIST_TTLS.collections,
      tags: ["collections"],
    },
    notifications: {
      domain: "notifications",
      revisionDomain: "notifications",
      freshForMs: DEFAULT_TTLS.notifications,
      persistForMs: DEFAULT_PERSIST_TTLS.notifications,
      tags: ["notifications"],
    },
    recommendations: {
      domain: "recommendations",
      revisionDomain: "recommendations",
      freshForMs: DEFAULT_TTLS.recommendations,
      persistForMs: DEFAULT_PERSIST_TTLS.recommendations,
      tags: ["recommendations"],
    },
    wishlistStatus: {
      domain: "wishlistStatus",
      revisionDomain: "lists",
      freshForMs: 30 * 1000,
      persistForMs: DAY_MS,
      tags: ["wishlistStatus", "wishlist", "lists"],
    },
    avatar: {
      domain: "avatar",
      revisionDomain: "profile",
      freshForMs: 30 * DAY_MS,
      persistForMs: 365 * DAY_MS,
      tags: ["avatar", "profile"],
    },
  };

  const CACHE_NAMESPACE = "garden-cache";
  const STORAGE_NAME = "mrmaple-garden";
  const STORAGE_STORE = "cache";
  const MAX_MIRROR_BYTES = 120000;
  const MAX_ENTRIES = 400;
  const MAX_BYTES = 4 * 1024 * 1024;
  const MAX_IMAGE_BYTES = 2 * 1024 * 1024;
  const CACHE_EVENT_NAMESPACE = "garden-cache";
  const BROADCAST_CHANNEL_NAME = "mrmaple-garden-cache";
  const BROADCAST_STORAGE_KEY = `${CACHE_NAMESPACE}:broadcast`;
  const BROADCAST_SEEN_TTL_MS = 10 * 1000;
  const BROADCAST_SEEN_MAX = 200;
  const REMOTE_MUTATION_BATCH_MS = 16;
  const MANIFEST_ENDPOINT = "/apps/garden/v1/cache/revisions";
  const MANIFEST_REFRESH_DEBOUNCE_MS = 200;
  const MANIFEST_REFRESH_MIN_INTERVAL_MS = 2 * 60 * 1000;
  // While a garden tab is visible, poll the revision manifest on this interval
  // so a customer's own edits (which bump server revisions) self-heal across
  // widgets without waiting for a focus/visibility change. Keep this slow:
  // focus/visibility/auth events still check sooner, and the local refresh
  // cooldown prevents repeated background hits from visible account pages.
  const MANIFEST_POLL_INTERVAL_MS = 5 * 60 * 1000;
  const APP_PROXY_FETCH_CACHE_LIMIT = 120;
  const APP_PROXY_FETCH_PERSIST_PREFIX = "app-proxy-fetch";
  const APP_PROXY_FETCH_PERSIST_MAX_BODY_BYTES = 900 * 1024;
  const APP_PROXY_FETCH_IGNORE_PARAMS = new Set([
    "signature",
    "timestamp",
    "path_prefix",
    "_",
    "_r",
    "_ts",
  ]);
  const memoryEntries = new Map();
  const entryContentSignatures = new Map();
  const mirrorSerializedEntries = new Map();
  let memoryBytesTotal = 0;
  let memoryImageBytesTotal = 0;
  const pendingQueries = new Map();
  const domainRegistry = new Map(
    Object.entries(DEFAULT_POLICIES).map(([key, value]) => [key, { ...value }]),
  );
  const subscribers = new Map();
  const metrics = (window.__GardenCacheMetrics =
    window.__GardenCacheMetrics || {
      hit: 0,
      staleHit: 0,
      miss: 0,
      revalidate304: 0,
      revalidate200: 0,
      optimisticWrite: 0,
      rollback: 0,
      broadcastInvalidate: 0,
      evictionsByBytes: 0,
      evictionsByCount: 0,
      evictionsByTTL: 0,
      focusManifestCheck: 0,
      imageEvictions: 0,
      fetchCacheHit: 0,
      fetchCacheMiss: 0,
      fetchCacheDedupe: 0,
      fetchCacheInvalidation: 0,
    });
  if (!Object.prototype.hasOwnProperty.call(metrics, "evictionsByBytes")) {
    metrics.evictionsByBytes = 0;
  }
  if (!Object.prototype.hasOwnProperty.call(metrics, "evictionsByCount")) {
    metrics.evictionsByCount = 0;
  }
  if (!Object.prototype.hasOwnProperty.call(metrics, "evictionsByTTL")) {
    metrics.evictionsByTTL = 0;
  }
  if (!Object.prototype.hasOwnProperty.call(metrics, "imageEvictions")) {
    metrics.imageEvictions = 0;
  }
  if (!Object.prototype.hasOwnProperty.call(metrics, "fetchCacheHit")) {
    metrics.fetchCacheHit = 0;
  }
  if (!Object.prototype.hasOwnProperty.call(metrics, "fetchCacheMiss")) {
    metrics.fetchCacheMiss = 0;
  }
  if (!Object.prototype.hasOwnProperty.call(metrics, "fetchCacheDedupe")) {
    metrics.fetchCacheDedupe = 0;
  }
  if (!Object.prototype.hasOwnProperty.call(metrics, "fetchCacheInvalidation")) {
    metrics.fetchCacheInvalidation = 0;
  }
  const broadcastSourceId = `garden-cache-${Date.now().toString(36)}-${Math.random()
    .toString(36)
    .slice(2, 10)}`;
  let storagePromise;
  let broadcastChannel = null;
  const seenBroadcastMutations = new Map();
  const pendingRemoteMutations = new Map();
  let remoteMutationFlushTimer = null;
  let manifestRefreshPromise = null;
  let manifestRefreshTimer = null;
  let manifestPollTimer = null;
  let manifestWatcherBound = false;
  let manifestState = {
    checkedAt: 0,
    etag: null,
    revisions: null,
    scope: null,
  };

  function sanitizeScopeValue(value) {
    if (value == null) {
      return null;
    }

    const normalized = String(value).trim();
    return normalized && normalized !== "null" ? normalized : null;
  }

  function resolveShop(options = {}) {
    return (
      sanitizeScopeValue(options.shop) ||
      sanitizeScopeValue(window.Shopify?.shop) ||
      sanitizeScopeValue(window.Shopify?.shopDomain) ||
      sanitizeScopeValue(
        document.querySelector("[data-shop-domain]")?.getAttribute(
          "data-shop-domain",
        ),
      ) ||
      "default"
    );
  }

  function resolveCustomerId(options = {}) {
    return (
      sanitizeScopeValue(options.customerId) ||
      sanitizeScopeValue(window.ShopifyCustomer?.id) ||
      sanitizeScopeValue(
        document.querySelector("[data-customer-id]")?.getAttribute(
          "data-customer-id",
        ),
      ) ||
      "anonymous"
    );
  }

  function buildKey(module, options = {}) {
    return [
      CACHE_NAMESPACE,
      resolveShop(options),
      resolveCustomerId(options),
      String(module || ""),
    ].join(":");
  }

  function buildScopedPrefix(options = {}) {
    return [
      CACHE_NAMESPACE,
      resolveShop(options),
      resolveCustomerId(options),
      "",
    ].join(":");
  }

  function resolveRequestUrl(input) {
    if (typeof input === "string") {
      return input;
    }

    if (input instanceof URL) {
      return input.toString();
    }

    if (input && typeof input === "object" && typeof input.url === "string") {
      return input.url;
    }

    return "";
  }

  function resolveRequestMethod(input, init = {}) {
    const method =
      init?.method ||
      (input && typeof input === "object" && typeof input.method === "string"
        ? input.method
        : "GET");
    return String(method || "GET").trim().toUpperCase();
  }

  function normalizeRequestBodyForKey(init = {}) {
    const body = init?.body;
    if (body == null) {
      return "";
    }

    if (typeof body === "string") {
      return body;
    }

    if (body instanceof URLSearchParams) {
      return body.toString();
    }

    if (body instanceof FormData) {
      const parts = [];
      body.forEach((value, key) => {
        parts.push(`${key}=${value instanceof File ? value.name : String(value)}`);
      });
      return parts.sort().join("&");
    }

    return "";
  }

  const ITEM_ONLY_MUTATION_FIELDS = new Set([
    "description",
    "careNotes",
    "tags",
    "photoDetails",
  ]);

  function parseJsonRequestBody(init = {}) {
    const body = init?.body;
    if (typeof body !== "string" || !body.trim()) {
      return null;
    }

    const contentType = normalizeHeaderValue(init?.headers, "content-type");
    if (contentType && !contentType.toLowerCase().includes("json")) {
      return null;
    }

    try {
      const parsed = JSON.parse(body);
      return parsed && typeof parsed === "object" && !Array.isArray(parsed)
        ? parsed
        : null;
    } catch {
      return null;
    }
  }

  function isItemOnlyMutationBody(body) {
    if (!body || typeof body !== "object" || Array.isArray(body)) {
      return false;
    }

    const fields = Object.keys(body).filter((key) => body[key] !== undefined);
    return (
      fields.length > 0 &&
      fields.every((field) => ITEM_ONLY_MUTATION_FIELDS.has(field))
    );
  }

  function normalizeHeaderValue(headers, name) {
    if (!headers) {
      return "";
    }

    try {
      if (headers instanceof Headers) {
        return headers.get(name) || "";
      }
      const lowerName = String(name || "").toLowerCase();
      if (Array.isArray(headers)) {
        const match = headers.find(
          ([key]) => String(key || "").toLowerCase() === lowerName,
        );
        return match ? String(match[1] || "") : "";
      }
      if (typeof headers === "object") {
        const key = Object.keys(headers).find(
          (candidate) => candidate.toLowerCase() === lowerName,
        );
        return key ? String(headers[key] || "") : "";
      }
    } catch {
      // Best-effort only.
    }

    return "";
  }

  function hashCacheKey(value) {
    const input = String(value || "");
    let hash = 2166136261;

    for (let index = 0; index < input.length; index += 1) {
      hash ^= input.charCodeAt(index);
      hash = Math.imul(hash, 16777619);
    }

    return String(hash >>> 0);
  }

  function normalizeAppProxyPath(pathname) {
    const normalized = String(pathname || "");
    const appProxyIndex = normalized.indexOf("/app_proxy/garden/v1");
    if (appProxyIndex >= 0) {
      return normalized.slice(appProxyIndex + "/app_proxy/garden/v1".length) || "/";
    }

    const storefrontIndex = normalized.indexOf("/apps/garden/v1");
    if (storefrontIndex >= 0) {
      return normalized.slice(storefrontIndex + "/apps/garden/v1".length) || "/";
    }

    return null;
  }

  function normalizeAppProxyFetchGroup(endpointPath) {
    const firstSegment = String(endpointPath || "")
      .replace(/^\/+/, "")
      .split("/")[0]
      ?.trim();
    return firstSegment
      ? firstSegment.replace(/[^a-z0-9_-]+/gi, "-").toLowerCase()
      : "root";
  }

  function resolveFetchTtl(endpointPath, searchParams, method) {
    const capRefreshTtl = (ttlMs) =>
      searchParams?.get("refresh") === "1"
        ? Math.min(ttlMs, 8 * 1000)
        : ttlMs;

    if (method === "POST" && endpointPath === "/auth/sync-customer") {
      return 50 * 60 * 1000;
    }

    if (method === "POST" && endpointPath === "/status/bulk") {
      return capRefreshTtl(60 * 1000);
    }

    if (method !== "GET") {
      return 0;
    }

    if (endpointPath === "/cache/revisions") return MANIFEST_REFRESH_MIN_INTERVAL_MS;
    if (endpointPath === "/status") return capRefreshTtl(60 * 1000);
    if (endpointPath === "/notifications/data") {
      return capRefreshTtl(45 * 1000);
    }
    if (endpointPath === "/notifications/search") return capRefreshTtl(60 * 1000);
    if (endpointPath === "/notifications/profile") return capRefreshTtl(60 * 1000);
    if (endpointPath === "/recommendations") return capRefreshTtl(15 * 60 * 1000);
    if (endpointPath === "/profile") return capRefreshTtl(60 * 1000);
    if (endpointPath === "/tiers/current") return capRefreshTtl(60 * 1000);
    if (endpointPath === "/achievements") return capRefreshTtl(60 * 1000);
    if (endpointPath === "/collections" || endpointPath.startsWith("/collections/")) {
      return capRefreshTtl(5 * 60 * 1000);
    }
    if (endpointPath === "/lists" || endpointPath.startsWith("/lists/")) {
      return capRefreshTtl(60 * 1000);
    }
    if (endpointPath === "/wishlist/items") return capRefreshTtl(60 * 1000);
    if (endpointPath === "/wishlist/availability") return capRefreshTtl(30 * 1000);
    if (endpointPath === "/subscriptions") {
      return capRefreshTtl(searchParams?.get("active") === "1" ? 30 * 1000 : 60 * 1000);
    }
    if (endpointPath === "/items") return capRefreshTtl(30 * 1000);
    if (endpointPath === "/demand/products") return capRefreshTtl(30 * 1000);
    if (endpointPath === "/demand/top-products") return capRefreshTtl(30 * 60 * 1000);
    if (endpointPath === "/share/settings" || endpointPath.startsWith("/share/settings/")) {
      return capRefreshTtl(5 * 60 * 1000);
    }
    if (endpointPath === "/backfill") return capRefreshTtl(15 * 1000);
    if (endpointPath === "/rank") return capRefreshTtl(60 * 1000);

    return 0;
  }

  function mutationInvalidationTokens(endpointPath, method, requestBody = null) {
    if (method === "GET") {
      return [];
    }

    if (endpointPath === "/notifications/toggle") {
      return ["/notifications/data", "/notifications/profile", "/subscriptions"];
    }

    if (endpointPath === "/notifications/profile") {
      return ["/notifications/profile", "/notifications/data"];
    }

    if (endpointPath === "/profile") {
      return ["/profile", "/tiers/current", "/achievements", "/rank"];
    }

    if (endpointPath === "/backfill" || endpointPath.startsWith("/backfill")) {
      return ["/backfill", "/profile", "/items", "/collections", "/tiers/current", "/rank", "/achievements"];
    }

    if (endpointPath === "/items" || endpointPath.startsWith("/items/")) {
      if (isItemOnlyMutationBody(requestBody)) {
        return ["/items"];
      }
      return ["/items", "/collections", "/profile", "/tiers/current", "/rank", "/achievements"];
    }

    if (endpointPath === "/lists" || endpointPath.startsWith("/lists/")) {
      // "/status" covers /status and /status/bulk, which back the product-card
      // heart state. Without it a list add/remove leaves cached heart statuses
      // showing the pre-mutation value until the revision manifest poll catches
      // up, so cards drift out of sync with the drawer and pane.
      return [
        "/lists",
        "/wishlist/items",
        "/wishlist/availability",
        "/status",
        "/notifications/data",
      ];
    }

    return [];
  }

  function getAppProxyFetchPolicy(input, init = {}) {
    const rawUrl = resolveRequestUrl(input);
    if (!rawUrl || typeof window.fetch !== "function") {
      return null;
    }

    let url;
    try {
      url = new URL(rawUrl, window.location.href);
    } catch {
      return null;
    }

    const endpointPath = normalizeAppProxyPath(url.pathname);
    if (!endpointPath) {
      return null;
    }

    const method = resolveRequestMethod(input, init);
    const bodyKey = method === "GET" || method === "HEAD" ? "" : normalizeRequestBodyForKey(init);
    const requestBody = method === "GET" || method === "HEAD" ? null : parseJsonRequestBody(init);
    const ttlMs = resolveFetchTtl(endpointPath, url.searchParams, method);
    const isCacheable = ttlMs > 0;
    const dedupeOnly =
      !isCacheable &&
      endpointPath === "/notifications/toggle" &&
      (method === "POST" || method === "DELETE");

    if (!isCacheable && !dedupeOnly) {
      return {
        endpointPath,
        method,
        cacheable: false,
        dedupe: false,
        invalidates: mutationInvalidationTokens(endpointPath, method, requestBody),
      };
    }

    const normalizedParams = [];
    url.searchParams.forEach((value, key) => {
      if (APP_PROXY_FETCH_IGNORE_PARAMS.has(key)) {
        return;
      }
      if (key === "shop" || key === "logged_in_customer_id") {
        return;
      }
      normalizedParams.push([key, value]);
    });
    normalizedParams.sort(([leftKey, leftValue], [rightKey, rightValue]) => {
      if (leftKey === rightKey) return leftValue.localeCompare(rightValue);
      return leftKey.localeCompare(rightKey);
    });

    const shop = sanitizeScopeValue(url.searchParams.get("shop")) || resolveShop();
    const customerId =
      sanitizeScopeValue(url.searchParams.get("logged_in_customer_id")) ||
      resolveCustomerId();
    const accept = normalizeHeaderValue(init?.headers, "accept");
    const contentType = normalizeHeaderValue(init?.headers, "content-type");
    const key = [
      "app-proxy-fetch",
      shop,
      customerId,
      method,
      endpointPath,
      normalizedParams.map(([paramKey, value]) => `${paramKey}=${value}`).join("&"),
      bodyKey,
      accept,
      contentType,
    ].join("|");

    return {
      endpointPath,
      method,
      key,
      shop,
      customerId,
      ttlMs,
      cacheable: isCacheable,
      dedupe: true,
      invalidates: mutationInvalidationTokens(endpointPath, method, requestBody),
    };
  }

  function getPersistedFetchModule(policy) {
    if (!policy?.key || !policy?.endpointPath) {
      return "";
    }

    return [
      APP_PROXY_FETCH_PERSIST_PREFIX,
      normalizeAppProxyFetchGroup(policy.endpointPath),
      hashCacheKey(policy.key),
    ].join(":");
  }

  function getPersistedFetchOptions(policy) {
    const ttlMs = Math.max(1, Number(policy?.ttlMs) || 0);
    const group = normalizeAppProxyFetchGroup(policy?.endpointPath);

    return {
      shop: policy?.shop || resolveShop(),
      customerId: policy?.customerId || resolveCustomerId(),
      maxAgeMs: ttlMs,
      persistForMs: ttlMs,
      domain: APP_PROXY_FETCH_PERSIST_PREFIX,
      revisionDomain: APP_PROXY_FETCH_PERSIST_PREFIX,
      tags: [APP_PROXY_FETCH_PERSIST_PREFIX, `${APP_PROXY_FETCH_PERSIST_PREFIX}:${group}`],
      broadcast: false,
    };
  }

  function recordResponseHeaders(headers) {
    const record = {};
    if (!headers || typeof headers.forEach !== "function") {
      return record;
    }

    headers.forEach((value, key) => {
      record[key] = value;
    });
    return record;
  }

  function buildPersistedFetchResponse(payload) {
    if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
      return null;
    }

    const status = Number(payload.status);
    const bodyText = typeof payload.bodyText === "string" ? payload.bodyText : null;
    if (!Number.isFinite(status) || status < 200 || status > 599 || bodyText === null) {
      return null;
    }

    return new Response(bodyText, {
      status,
      statusText: typeof payload.statusText === "string" ? payload.statusText : "",
      headers: payload.headers && typeof payload.headers === "object" ? payload.headers : {},
    });
  }

  async function readPersistedFetchResponse(policy) {
    if (!policy?.cacheable) {
      return null;
    }

    const module = getPersistedFetchModule(policy);
    if (!module) {
      return null;
    }

    const options = getPersistedFetchOptions(policy);
    try {
      const entry = await readEntry(module, options);
      if (!entry || !isFresh(module, entry, options)) {
        return null;
      }
      return buildPersistedFetchResponse(entry.data);
    } catch (error) {
      debugWarn("[Garden Cache] Failed to read persisted fetch response:", error);
      return null;
    }
  }

  async function persistFetchResponse(policy, response) {
    if (!policy?.cacheable || !response || !response.ok || response.status === 204) {
      return;
    }

    const module = getPersistedFetchModule(policy);
    if (!module) {
      return;
    }

    try {
      const bodyText = await response.clone().text();
      if (bodyText.length > APP_PROXY_FETCH_PERSIST_MAX_BODY_BYTES) {
        return;
      }

      await write(
        module,
        {
          status: response.status,
          statusText: response.statusText || "",
          headers: recordResponseHeaders(response.headers),
          bodyText,
        },
        getPersistedFetchOptions(policy),
      );
    } catch (error) {
      debugWarn("[Garden Cache] Failed to persist fetch response:", error);
    }
  }

  function invalidatePersistedFetchCache(tokens) {
    const targets = Array.isArray(tokens) ? tokens.filter(Boolean) : [];
    if (!targets.length || typeof invalidatePrefix !== "function") {
      return;
    }

    const groups = new Set(
      targets.map((target) => normalizeAppProxyFetchGroup(target)).filter(Boolean),
    );

    groups.forEach((group) => {
      void invalidatePrefix(`${APP_PROXY_FETCH_PERSIST_PREFIX}:${group}:`, {
        customerId: resolveCustomerId(),
        shop: resolveShop(),
        broadcast: false,
        source: "local",
      });
    });
  }

  function installAppProxyFetchCache() {
    if (
      window.__MrMapleGardenFetchCacheInstalled ||
      typeof window.fetch !== "function"
    ) {
      return;
    }

    const nativeFetch = window.fetch.bind(window);
    const pendingFetches = new Map();
    const cachedFetches = new Map();
    window.__MrMapleGardenFetchCacheInstalled = true;

    function pruneFetchCache() {
      const now = Date.now();
      Array.from(cachedFetches.entries()).forEach(([key, entry]) => {
        if (!entry || entry.expiresAt <= now) {
          cachedFetches.delete(key);
        }
      });

      while (cachedFetches.size > APP_PROXY_FETCH_CACHE_LIMIT) {
        const oldestKey = cachedFetches.keys().next().value;
        if (!oldestKey) break;
        cachedFetches.delete(oldestKey);
      }
    }

    function invalidateFetchCache(tokens) {
      const targets = Array.isArray(tokens) ? tokens.filter(Boolean) : [];
      if (!targets.length) {
        return;
      }

      let invalidated = 0;
      Array.from(cachedFetches.keys()).forEach((key) => {
        if (targets.some((target) => key.includes(`|${target}`))) {
          cachedFetches.delete(key);
          invalidated += 1;
        }
      });

      if (invalidated > 0) {
        incrementMetric("fetchCacheInvalidation");
      }

      invalidatePersistedFetchCache(targets);
    }

    function shouldStoreFetchResponse(response) {
      if (!response || !response.ok || response.status === 204) {
        return false;
      }

      const cacheControl = response.headers?.get?.("cache-control") || "";
      return !/\bno-store\b/i.test(cacheControl);
    }

    window.fetch = function cachedGardenFetch(input, init) {
      const policy = getAppProxyFetchPolicy(input, init || {});
      if (!policy || (!policy.dedupe && !policy.cacheable)) {
        // Mutations (DELETE/POST/PATCH) are neither cacheable nor dedupe, but
        // they still carry invalidation tokens. Without flushing those, a write
        // like wishlist "Clear All" leaves the superseded GET cache (e.g.
        // /wishlist/items) populated, so the data reappears on next read.
        if (policy && Array.isArray(policy.invalidates) && policy.invalidates.length) {
          return nativeFetch(input, init).then((response) => {
            if (response && response.ok) {
              invalidateFetchCache(policy.invalidates);
            }
            return response;
          });
        }
        return nativeFetch(input, init);
      }

      const now = Date.now();
      if (policy.cacheable) {
        pruneFetchCache();
        const cached = cachedFetches.get(policy.key);
        if (cached && cached.expiresAt > now) {
          cached.lastAccess = now;
          cachedFetches.delete(policy.key);
          cachedFetches.set(policy.key, cached);
          incrementMetric("fetchCacheHit");
          return Promise.resolve(cached.response.clone());
        }
      }

      if (pendingFetches.has(policy.key)) {
        incrementMetric("fetchCacheDedupe");
        return pendingFetches.get(policy.key).then((response) => response.clone());
      }

      const networkPromise = (async () => {
        if (policy.cacheable) {
          const persistedResponse = await readPersistedFetchResponse(policy);
          if (persistedResponse) {
            incrementMetric("fetchCacheHit");
            return persistedResponse;
          }
        }

        incrementMetric("fetchCacheMiss");
        return nativeFetch(input, init).then((response) => {
          const masterResponse = response.clone();
          if (policy.cacheable && shouldStoreFetchResponse(masterResponse)) {
            cachedFetches.set(policy.key, {
              response: masterResponse.clone(),
              expiresAt: Date.now() + policy.ttlMs,
              lastAccess: Date.now(),
            });
            pruneFetchCache();
            void persistFetchResponse(policy, masterResponse.clone());
          }

          if (Array.isArray(policy.invalidates) && policy.invalidates.length && response.ok) {
            invalidateFetchCache(policy.invalidates);
          }

          return masterResponse;
        });
      })()
        .finally(() => {
          pendingFetches.delete(policy.key);
        });

      pendingFetches.set(policy.key, networkPromise);
      return networkPromise.then((response) => response.clone());
    };

    window.MrMapleGardenFetchCache = {
      invalidate: invalidateFetchCache,
      clear() {
        cachedFetches.clear();
        pendingFetches.clear();
      },
      size() {
        return cachedFetches.size;
      },
      policyFor(input, init) {
        return getAppProxyFetchPolicy(input, init || {});
      },
    };
  }

  function parseEntry(value) {
    if (!value || typeof value !== "object" || Array.isArray(value)) {
      return null;
    }

    if (!Object.prototype.hasOwnProperty.call(value, "data")) {
      return null;
    }

    const savedAt = Number(value.savedAt);
    if (!Number.isFinite(savedAt) || savedAt <= 0) {
      return null;
    }

    const entry = {
      data: value.data,
      savedAt,
    };

    if (value.version != null) {
      entry.version = value.version;
    }

    if (typeof value.etag === "string" && value.etag.trim()) {
      entry.etag = value.etag.trim();
    }

    if (value.revision != null) {
      entry.revision = String(value.revision);
    }

    if (
      typeof value.revisionDomain === "string" &&
      value.revisionDomain.trim()
    ) {
      entry.revisionDomain = value.revisionDomain.trim();
    }

    if (typeof value.domain === "string" && value.domain.trim()) {
      entry.domain = value.domain.trim();
    }

    if (Array.isArray(value.tags)) {
      entry.tags = value.tags
        .map((tag) => String(tag || "").trim())
        .filter(Boolean);
    }

    const freshForMs = Number(value.freshForMs);
    if (Number.isFinite(freshForMs) && freshForMs >= 0) {
      entry.freshForMs = freshForMs;
    }

    const persistForMs = Number(value.persistForMs);
    if (Number.isFinite(persistForMs) && persistForMs >= 0) {
      entry.persistForMs = persistForMs;
    }

    return entry;
  }

  function normalizeTags(tags) {
    if (!Array.isArray(tags)) {
      if (typeof tags === "string") {
        return tags
          .split(",")
          .map((value) => value.trim())
          .filter(Boolean);
      }
      return [];
    }

    return tags.map((value) => String(value || "").trim()).filter(Boolean);
  }

  function uniqueArray(values) {
    return Array.from(new Set((Array.isArray(values) ? values : []).filter(Boolean)));
  }

  function inferDomainFromModule(module) {
    const normalized = String(module || "").trim();
    if (!normalized) {
      return null;
    }

    if (DEFAULT_POLICIES[normalized]) {
      return DEFAULT_POLICIES[normalized].domain || normalized;
    }

    if (normalized === "garden-collections") {
      return "collections";
    }

    if (normalized.startsWith("notifications")) {
      return "notifications";
    }

    if (normalized.startsWith("wishlist:lists:")) {
      return "lists";
    }

    if (normalized.startsWith("wishlist:status:")) {
      return "wishlistStatus";
    }

    if (normalized.startsWith("wishlist:recommendations:")) {
      return "recommendations";
    }

    return normalized.split(":")[0] || null;
  }

  function resolvePolicy(module, options = {}, entry) {
    const inferredDomain =
      options.domain ||
      entry?.domain ||
      inferDomainFromModule(module) ||
      "default";
    const basePolicy =
      domainRegistry.get(inferredDomain) ||
      domainRegistry.get(String(module || "").trim()) ||
      {};
    const prefixPolicy = PREFIX_TTLS.find(([prefix]) =>
      String(module || "").startsWith(prefix),
    );
    const freshForMs = Number(options.maxAgeMs);
    const persistForMs = Number(options.persistForMs);
    const entryFreshForMs = Number(entry?.freshForMs);
    const entryPersistForMs = Number(entry?.persistForMs);
    const resolvedFreshForMs =
      Number.isFinite(freshForMs) && freshForMs >= 0
        ? freshForMs
        : Number.isFinite(entryFreshForMs) && entryFreshForMs >= 0
          ? entryFreshForMs
          : Number(basePolicy.freshForMs) >= 0
            ? Number(basePolicy.freshForMs)
            : prefixPolicy?.[1] || DEFAULT_TTLS[module] || 5 * 60 * 1000;
    const resolvedPersistForMs =
      Number.isFinite(persistForMs) && persistForMs >= 0
        ? persistForMs
        : Number.isFinite(entryPersistForMs) && entryPersistForMs >= 0
          ? entryPersistForMs
          : Number(basePolicy.persistForMs) >= 0
            ? Number(basePolicy.persistForMs)
            : Math.max(
                DEFAULT_PERSIST_TTLS[inferredDomain] || resolvedFreshForMs,
                resolvedFreshForMs,
              );

    return {
      domain: inferredDomain,
      revisionDomain:
        typeof options.revisionDomain === "string" && options.revisionDomain.trim()
          ? options.revisionDomain.trim()
          : entry?.revisionDomain ||
            basePolicy.revisionDomain ||
            inferredDomain,
      freshForMs: resolvedFreshForMs,
      persistForMs: resolvedPersistForMs,
      tags: uniqueArray([
        ...(basePolicy.tags || []),
        inferredDomain,
        ...normalizeTags(options.tags),
        ...normalizeTags(entry?.tags),
      ]),
    };
  }

  function createEntry(module, data, options = {}, currentEntry) {
    const policy = resolvePolicy(module, options, currentEntry);
    const entry = {
      data,
      savedAt: Number(options.savedAt) || Date.now(),
      freshForMs: policy.freshForMs,
      persistForMs: policy.persistForMs,
      revisionDomain: policy.revisionDomain || null,
      domain: policy.domain || null,
      tags: policy.tags,
    };

    const version =
      options.version != null ? options.version : currentEntry?.version ?? null;
    if (version != null) {
      entry.version = version;
    }

    const etag =
      typeof options.etag === "string" && options.etag.trim()
        ? options.etag.trim()
        : currentEntry?.etag || null;
    if (etag) {
      entry.etag = etag;
    }

    const revision =
      options.revision != null
        ? String(options.revision)
        : currentEntry?.revision != null
          ? String(currentEntry.revision)
          : null;
    if (revision) {
      entry.revision = revision;
    }

    return entry;
  }

  function readMirrorByKey(key) {
    const storageKey = String(key);
    try {
      const raw = window.localStorage.getItem(storageKey);
      if (!raw) {
        mirrorSerializedEntries.delete(storageKey);
        entryContentSignatures.delete(storageKey);
        return null;
      }
      mirrorSerializedEntries.set(storageKey, raw);
      const entry = parseEntry(JSON.parse(raw));
      rememberEntryContentSignature(storageKey, entry);
      return entry;
    } catch {
      mirrorSerializedEntries.delete(storageKey);
      entryContentSignatures.delete(storageKey);
      return null;
    }
  }

  function serializeEntryContent(entry) {
    if (!entry || typeof entry !== "object") {
      return "";
    }

    try {
      const { savedAt: _savedAt, ...content } = entry;
      return JSON.stringify(content);
    } catch {
      return "";
    }
  }

  function rememberEntryContentSignature(key, entry) {
    const storageKey = String(key);
    const signature = serializeEntryContent(entry);
    if (signature) {
      entryContentSignatures.set(storageKey, signature);
    } else {
      entryContentSignatures.delete(storageKey);
    }
    return signature;
  }

  function entryMatchesKnownContent(key, entry, currentEntry = null) {
    const nextSignature = serializeEntryContent(entry);
    if (!nextSignature) {
      return false;
    }

    if (currentEntry) {
      const currentSignature = serializeEntryContent(currentEntry);
      if (currentSignature && currentSignature === nextSignature) {
        return true;
      }
    }

    return entryContentSignatures.get(String(key)) === nextSignature;
  }

  function mergeRemoteFreshness(currentEntry, nextEntry) {
    if (!currentEntry || !nextEntry) {
      return currentEntry || nextEntry || null;
    }

    const currentSavedAt = Number(currentEntry.savedAt) || 0;
    const nextSavedAt = Number(nextEntry.savedAt) || 0;
    if (nextSavedAt <= currentSavedAt) {
      return currentEntry;
    }

    return {
      ...currentEntry,
      savedAt: nextSavedAt,
    };
  }

  function serializeMirrorEntry(entry) {
    try {
      const serialized = JSON.stringify(entry);
      if (
        typeof serialized === "string" &&
        serialized.length > 0 &&
        serialized.length <= MAX_MIRROR_BYTES
      ) {
        return serialized;
      }
    } catch {
      // Ignore mirror serialization failures.
    }

    return null;
  }

  function writeMirrorByKey(key, entry) {
    const storageKey = String(key);
    const serialized = serializeMirrorEntry(entry);
    if (!serialized) {
      removeMirrorByKey(key);
      return false;
    }

    if (mirrorSerializedEntries.get(storageKey) === serialized) {
      rememberEntryContentSignature(storageKey, entry);
      return false;
    }

    try {
      window.localStorage.setItem(storageKey, serialized);
      mirrorSerializedEntries.set(storageKey, serialized);
      rememberEntryContentSignature(storageKey, entry);
      return true;
    } catch {
      // Ignore quota and storage availability failures.
    }

    return false;
  }

  function removeMirrorByKey(key) {
    const storageKey = String(key);
    try {
      window.localStorage.removeItem(storageKey);
    } catch {
      // Ignore storage availability failures.
    }
    mirrorSerializedEntries.delete(storageKey);
    entryContentSignatures.delete(storageKey);
  }

  async function getStorage() {
    if (storagePromise) {
      return storagePromise;
    }

    storagePromise = (async () => {
      if (!window.localforage) {
        return null;
      }

      try {
        const store = window.localforage.createInstance({
          name: STORAGE_NAME,
          storeName: STORAGE_STORE,
        });

        if (typeof store.setDriver === "function") {
          try {
            await store.setDriver([
              window.localforage.INDEXEDDB,
              window.localforage.LOCALSTORAGE,
            ]);
          } catch {
            // Fall back to the default driver selection.
          }
        }

        if (typeof store.ready === "function") {
          await store.ready();
        }

        return store;
      } catch (error) {
        console.warn("[Garden Cache] Persistent storage unavailable:", error);
        return null;
      }
    })();

    return storagePromise;
  }

  function modulePartFromStorageKey(storageKey) {
    const prefix = `${CACHE_NAMESPACE}:`;
    const raw = String(storageKey || "");
    if (!raw.startsWith(prefix)) {
      return "";
    }
    const rest = raw.slice(prefix.length);
    const shopEnd = rest.indexOf(":");
    if (shopEnd === -1) {
      return "";
    }
    const customerEnd = rest.indexOf(":", shopEnd + 1);
    if (customerEnd === -1) {
      return "";
    }
    return rest.slice(customerEnd + 1);
  }

  function isImageMemoryKey(storageKey) {
    return modulePartFromStorageKey(storageKey).startsWith("image:");
  }

  function estimateMemoryEntryBytes(storageKey, entry) {
    let n = 96 + String(storageKey).length * 2;
    if (!entry || typeof entry !== "object") {
      return n;
    }
    const data = entry.data;
    if (typeof data === "string") {
      return n + data.length * 2;
    }
    if (data != null && typeof data === "object") {
      if (typeof data.src === "string") {
        n += data.src.length * 2;
      }
      if (typeof data.originalUrl === "string") {
        n += data.originalUrl.length * 2;
      }
      if (typeof data.src === "string") {
        n += 256;
      } else {
        try {
          n += JSON.stringify(data).length;
        } catch {
          n += 2048;
        }
      }
      return n;
    }
    try {
      n += JSON.stringify(data).length;
    } catch {
      n += 512;
    }
    return n;
  }

  function enforceMemoryBudget() {
    let guard = 0;
    const maxIterations = Math.max(memoryEntries.size, 1) + 64;
    while (
      memoryEntries.size > MAX_ENTRIES ||
      memoryBytesTotal > MAX_BYTES ||
      memoryImageBytesTotal > MAX_IMAGE_BYTES
    ) {
      guard += 1;
      if (guard > maxIterations) {
        debugWarn(
          "[Garden Cache] In-memory cache budget enforcement did not converge; clearing memory cache.",
          { size: memoryEntries.size, memoryBytesTotal, memoryImageBytesTotal },
        );
        memoryEntries.clear();
        memoryBytesTotal = 0;
        memoryImageBytesTotal = 0;
        break;
      }

      const oldestKey = memoryEntries.keys().next().value;
      if (oldestKey === undefined) {
        memoryBytesTotal = 0;
        memoryImageBytesTotal = 0;
        break;
      }

      const victim = memoryEntries.get(oldestKey);
      const victimBytes = estimateMemoryEntryBytes(oldestKey, victim);
      const exceededCount = memoryEntries.size > MAX_ENTRIES;
      const exceededBytes = memoryBytesTotal > MAX_BYTES;
      const exceededImageBytes = memoryImageBytesTotal > MAX_IMAGE_BYTES;
      memoryEntries.delete(oldestKey);
      memoryBytesTotal = Math.max(0, memoryBytesTotal - victimBytes);
      if (isImageMemoryKey(oldestKey)) {
        memoryImageBytesTotal = Math.max(0, memoryImageBytesTotal - victimBytes);
      }
      if (exceededCount) incrementMetric("evictionsByCount");
      if (exceededBytes) incrementMetric("evictionsByBytes");
      if (exceededImageBytes) incrementMetric("imageEvictions");
    }
  }

  function touchMemoryKey(storageKey) {
    const key = String(storageKey);
    if (!memoryEntries.has(key)) {
      return;
    }
    const entry = memoryEntries.get(key);
    memoryEntries.delete(key);
    memoryEntries.set(key, entry);
  }

  function rememberEntry(key, entry) {
    const k = String(key);
    if (memoryEntries.has(k)) {
      const prev = memoryEntries.get(k);
      const prevBytes = estimateMemoryEntryBytes(k, prev);
      memoryBytesTotal = Math.max(0, memoryBytesTotal - prevBytes);
      if (isImageMemoryKey(k)) {
        memoryImageBytesTotal = Math.max(0, memoryImageBytesTotal - prevBytes);
      }
      memoryEntries.delete(k);
    }

    if (!entry) {
      entryContentSignatures.delete(k);
      return null;
    }

    memoryEntries.set(k, entry);
    rememberEntryContentSignature(k, entry);
    const added = estimateMemoryEntryBytes(k, entry);
    memoryBytesTotal += added;
    if (isImageMemoryKey(k)) {
      memoryImageBytesTotal += added;
    }
    enforceMemoryBudget();
    return entry;
  }

  function ttlFor(module, options = {}) {
    return resolvePolicy(module, options).freshForMs;
  }

  function persistTtlFor(module, options = {}, entry) {
    return resolvePolicy(module, options, entry).persistForMs;
  }

  function isFresh(module, entry, options = {}) {
    return Boolean(entry?.savedAt) && Date.now() - entry.savedAt < ttlFor(module, options);
  }

  function isPersistedAlive(module, entry, options = {}) {
    if (!entry?.savedAt) {
      return false;
    }

    return Date.now() - entry.savedAt < persistTtlFor(module, options, entry);
  }

  function peek(module, options = {}) {
    const key = buildKey(module, options);
    const cached = memoryEntries.get(key);
    if (cached) {
      touchMemoryKey(key);
      return cached;
    }

    const mirrored = readMirrorByKey(key);
    if (mirrored) {
      rememberEntry(key, mirrored);
    }
    return mirrored;
  }

  async function readEntry(module, options = {}) {
    const key = buildKey(module, options);
    const cached = peek(module, options);
    if (cached) {
      return cached;
    }

    const storage = await getStorage();
    if (!storage) {
      return null;
    }

    try {
      const stored = parseEntry(await storage.getItem(key));
      if (stored) {
        rememberEntry(key, stored);
        writeMirrorByKey(key, stored);
      }
      return stored;
    } catch (error) {
      console.warn("[Garden Cache] Failed to read entry:", error);
      return peek(module, options);
    }
  }

  async function read(module, options = {}) {
    const entry = await readEntry(module, options);
    return entry?.data ?? null;
  }

  function incrementMetric(metric) {
    if (!metric || !Object.prototype.hasOwnProperty.call(metrics, metric)) {
      return;
    }
    metrics[metric] += 1;
    window.dispatchEvent(
      new CustomEvent(`${CACHE_EVENT_NAMESPACE}:metric`, {
        detail: {
          metric,
          value: metrics[metric],
        },
      }),
    );
  }

  function buildEventDetail(action, module, entry, options = {}) {
    const policy = resolvePolicy(module, options, entry);
    return {
      action,
      module,
      key: buildKey(module, options),
      entry: entry || null,
      data: entry?.data ?? null,
      version: entry?.version ?? null,
      etag: entry?.etag ?? null,
      revision: entry?.revision ?? null,
      revisionDomain: entry?.revisionDomain || policy.revisionDomain || null,
      domain: entry?.domain || policy.domain || null,
      tags: Array.isArray(entry?.tags) ? entry.tags.slice() : policy.tags,
      customerId: resolveCustomerId(options),
      shop: resolveShop(options),
      source: options.source || "local",
    };
  }

  function notifySubscribers(detail) {
    subscribers.forEach((callbacks, key) => {
      const isModuleSubscription =
        key === `module:${detail.module}` || key === `domain:${detail.domain}`;
      const isTagSubscription =
        key.startsWith("tag:") &&
        Array.isArray(detail.tags) &&
        detail.tags.includes(key.slice(4));

      if (!isModuleSubscription && !isTagSubscription) {
        return;
      }

      callbacks.forEach((callback) => {
        try {
          callback(detail);
        } catch (error) {
          console.warn("[Garden Cache] Subscriber callback failed:", error);
        }
      });
    });
  }

  let pendingLegacyListDetail = null;
  let pendingLegacyListTimer = null;

  function shouldEmitLegacyWishlistListEvent(detail) {
    if (!detail || detail.domain !== "lists") {
      return false;
    }

    const module = String(detail.module || "").trim();
    if (!module) {
      return true;
    }

    return (
      module === "wishlist:primary-items" ||
      module.startsWith("wishlist:lists:") ||
      module.startsWith("wishlist:list-items:")
    );
  }

  function scheduleLegacyWishlistListEvent(detail) {
    if (!shouldEmitLegacyWishlistListEvent(detail)) {
      return;
    }

    if (!pendingLegacyListDetail) {
      pendingLegacyListDetail = detail;
    }

    if (pendingLegacyListTimer !== null) {
      return;
    }

    pendingLegacyListTimer = window.setTimeout(() => {
      const nextDetail = pendingLegacyListDetail;
      pendingLegacyListDetail = null;
      pendingLegacyListTimer = null;
      if (!nextDetail) return;
      document.dispatchEvent(
        new CustomEvent("wl:lists:updated", {
          detail: nextDetail,
        }),
      );
    }, 0);
  }

  function emitLegacyAdapterEvents(detail) {
    if (detail.source === "local") {
      return;
    }

    if (detail.domain === "profile") {
      window.dispatchEvent(
        new CustomEvent("garden:profile-updated", {
          detail: {
            customerId: detail.customerId,
            source: detail.source,
            reason: "cache-sync",
          },
        }),
      );
    }

    scheduleLegacyWishlistListEvent(detail);

    if (detail.domain === "items") {
      window.dispatchEvent(
        new CustomEvent("garden:items-updated", {
          detail: {
            reason: "cache-sync",
            customerId: detail.customerId,
            source: detail.source,
          },
        }),
      );
    }
  }

  function emitChange(action, module, entry, options = {}) {
    const detail = buildEventDetail(action, module, entry, options);
    const eventName =
      action === "invalidate"
        ? `${CACHE_EVENT_NAMESPACE}:invalidated`
        : action === "revalidate"
          ? `${CACHE_EVENT_NAMESPACE}:revalidated`
          : action === "rollback"
            ? `${CACHE_EVENT_NAMESPACE}:rolled-back`
            : `${CACHE_EVENT_NAMESPACE}:changed`;

    window.dispatchEvent(
      new CustomEvent(eventName, {
        detail,
      }),
    );

    notifySubscribers(detail);
    emitLegacyAdapterEvents(detail);
    if (options.broadcast !== false) {
      broadcastCacheMutation(detail);
    }
  }

  async function write(module, data, options = {}) {
    const key = buildKey(module, options);
    const currentEntry = await readEntry(module, options);
    const entry = createEntry(module, data, options, currentEntry);

    rememberEntry(key, entry);
    writeMirrorByKey(key, entry);

    const storage = await getStorage();
    if (storage) {
      try {
        await storage.setItem(key, entry);
      } catch (error) {
        console.warn("[Garden Cache] Failed to persist entry:", error);
      }
    }

    emitChange("write", module, entry, options);
    return entry;
  }

  async function update(module, updater, options = {}) {
    const currentEntry = await readEntry(module, options);
    const nextData = await updater(currentEntry?.data ?? null, currentEntry);

    if (typeof nextData === "undefined") {
      return currentEntry || null;
    }

    const nextOptions = { ...options };
    if (
      !Object.prototype.hasOwnProperty.call(nextOptions, "version") &&
      currentEntry?.version != null
    ) {
      nextOptions.version = currentEntry.version;
    }

    return write(module, nextData, nextOptions);
  }

  async function invalidate(modules, options = {}) {
    const targets = Array.isArray(modules) ? modules : [modules];
    const storage = await getStorage();

    for (const module of targets) {
      const key = buildKey(module, options);
      rememberEntry(key, null);
      removeMirrorByKey(key);

      if (storage) {
        try {
          await storage.removeItem(key);
        } catch (error) {
          console.warn("[Garden Cache] Failed to remove entry:", error);
        }
      }

      emitChange("invalidate", module, null, options);
    }
  }

  function moduleFromKey(key, options = {}) {
    const scopedPrefix = buildScopedPrefix(options);
    if (String(key).startsWith(scopedPrefix)) {
      return String(key).slice(scopedPrefix.length);
    }

    return String(key || "");
  }

  async function findKeysByPrefix(prefix, options = {}) {
    const scopedPrefix = `${buildScopedPrefix(options)}${String(prefix || "")}`;
    const keys = new Set();

    memoryEntries.forEach((_entry, key) => {
      if (String(key).startsWith(scopedPrefix)) {
        keys.add(String(key));
      }
    });

    try {
      Object.keys(window.localStorage || {}).forEach((key) => {
        if (String(key).startsWith(scopedPrefix)) {
          keys.add(String(key));
        }
      });
    } catch {
      // Ignore storage enumeration failures.
    }

    const storage = await getStorage();
    if (storage && typeof storage.iterate === "function") {
      try {
        await storage.iterate((_value, key) => {
          if (String(key).startsWith(scopedPrefix)) {
            keys.add(String(key));
          }
        });
      } catch (error) {
        console.warn("[Garden Cache] Failed to enumerate keys:", error);
      }
    }

    return Array.from(keys);
  }

  async function invalidatePrefix(prefix, options = {}) {
    const storage = await getStorage();
    const keys = await findKeysByPrefix(prefix, options);

    for (const key of keys) {
      rememberEntry(key, null);
      removeMirrorByKey(key);

      if (storage) {
        try {
          await storage.removeItem(key);
        } catch (error) {
          console.warn("[Garden Cache] Failed to remove entry:", error);
        }
      }

      emitChange("invalidate", moduleFromKey(key, options), null, options);
    }
  }

  async function collectEntriesByPredicate(predicate, options = {}) {
    const scopedPrefix = buildScopedPrefix(options);
    const collected = new Map();

    memoryEntries.forEach((entry, key) => {
      if (!String(key).startsWith(scopedPrefix)) {
        return;
      }
      if (predicate(String(key), entry)) {
        collected.set(String(key), entry);
      }
    });

    try {
      Object.keys(window.localStorage || {}).forEach((key) => {
        if (collected.has(String(key)) || !String(key).startsWith(scopedPrefix)) {
          return;
        }

        const entry = readMirrorByKey(String(key));
        if (entry && predicate(String(key), entry)) {
          collected.set(String(key), entry);
        }
      });
    } catch {
      // Ignore storage enumeration failures.
    }

    const storage = await getStorage();
    if (storage && typeof storage.iterate === "function") {
      try {
        await storage.iterate((value, key) => {
          if (collected.has(String(key)) || !String(key).startsWith(scopedPrefix)) {
            return;
          }

          const entry = parseEntry(value);
          if (entry && predicate(String(key), entry)) {
            collected.set(String(key), entry);
          }
        });
      } catch (error) {
        console.warn("[Garden Cache] Failed to iterate entries:", error);
      }
    }

    return Array.from(collected.entries());
  }

  async function invalidateTags(tags, options = {}) {
    const targets = normalizeTags(tags);
    if (!targets.length) {
      return;
    }

    const entries = await collectEntriesByPredicate((_key, entry) => {
      const entryTags = normalizeTags(entry?.tags);
      return targets.some((target) => entryTags.includes(target));
    }, options);
    const storage = await getStorage();

    for (const [key] of entries) {
      rememberEntry(key, null);
      removeMirrorByKey(key);
      if (storage) {
        try {
          await storage.removeItem(key);
        } catch (error) {
          console.warn("[Garden Cache] Failed to remove tagged entry:", error);
        }
      }

      emitChange("invalidate", moduleFromKey(key, options), null, {
        ...options,
        source: options.source || "local",
      });
    }
  }

  function registerDomain(name, config = {}) {
    const normalized = String(name || "").trim();
    if (!normalized) {
      return null;
    }

    const nextPolicy = {
      ...(domainRegistry.get(normalized) || {}),
      ...config,
    };

    if (nextPolicy.tags) {
      nextPolicy.tags = normalizeTags(nextPolicy.tags);
    }

    domainRegistry.set(normalized, nextPolicy);
    return nextPolicy;
  }

  function subscribe(target, callback) {
    if (typeof callback !== "function") {
      return () => {};
    }

    let keys = [];
    if (typeof target === "string") {
      const normalized = target.trim();
      if (!normalized) {
        return () => {};
      }
      keys = [`module:${normalized}`, `domain:${normalized}`, `tag:${normalized}`];
    } else if (target && typeof target === "object") {
      if (typeof target.module === "string" && target.module.trim()) {
        keys.push(`module:${target.module.trim()}`);
      }
      if (typeof target.domain === "string" && target.domain.trim()) {
        keys.push(`domain:${target.domain.trim()}`);
      }
      keys.push(...normalizeTags(target.tags).map((tag) => `tag:${tag}`));
    }

    keys = uniqueArray(keys);
    keys.forEach((key) => {
      if (!subscribers.has(key)) {
        subscribers.set(key, new Set());
      }
      subscribers.get(key).add(callback);
    });

    return () => {
      keys.forEach((key) => {
        const callbacks = subscribers.get(key);
        if (!callbacks) {
          return;
        }
        callbacks.delete(callback);
        if (!callbacks.size) {
          subscribers.delete(key);
        }
      });
    };
  }

  async function hydrate(entries, options = {}) {
    const list = Array.isArray(entries) ? entries : [entries];
    await Promise.all(
      list
        .filter(Boolean)
        .map((entry) =>
          write(entry.module, entry.data, {
            ...options,
            ...entry,
            source: "hydrate",
            broadcast: false,
          }),
        ),
    );
  }

  function normalizeQueryInput(input, options = {}) {
    if (typeof input === "string") {
      return {
        module: input,
        ...options,
      };
    }

    return {
      ...(input || {}),
      ...options,
      module:
        options.module ||
        input?.module ||
        input?.key ||
        input?.domain,
    };
  }

  async function extractFetchResultPayload(result, config, entry) {
    if (result instanceof Response) {
      if (result.status === 304) {
        return {
          notModified: true,
          etag: result.headers.get("ETag"),
          revision: result.headers.get("X-Garden-Revision"),
        };
      }

      if (!result.ok) {
        throw new Error(`Cache query failed (${result.status})`);
      }

      const data = await result.json();
      return {
        data,
        etag: result.headers.get("ETag"),
        revision: result.headers.get("X-Garden-Revision"),
      };
    }

    if (
      result &&
      typeof result === "object" &&
      (Object.prototype.hasOwnProperty.call(result, "data") ||
        Object.prototype.hasOwnProperty.call(result, "notModified"))
    ) {
      return result;
    }

    return {
      data: typeof result === "undefined" ? entry?.data ?? null : result,
    };
  }

  async function refreshQuery(config, existingEntry, reason = "refresh") {
    const scopedOptions = {
      shop: config.shop,
      customerId: config.customerId,
      maxAgeMs: config.freshForMs ?? config.maxAgeMs,
      persistForMs: config.persistForMs,
      revisionDomain: config.revisionDomain,
      tags: config.tags,
      domain: config.domain,
      source: config.source || "local",
    };
    const key = buildKey(config.module, scopedOptions);

    if (!config.fetcher || typeof config.fetcher !== "function") {
      return {
        data: existingEntry?.data ?? null,
        entry: existingEntry ?? null,
        fromCache: Boolean(existingEntry),
        stale: Boolean(existingEntry),
      };
    }

    if (pendingQueries.has(key)) {
      return pendingQueries.get(key);
    }

    const requestPromise = (async () => {
      const requestHeaders = { ...(config.headers || {}) };
      if (existingEntry?.etag) {
        requestHeaders["If-None-Match"] = existingEntry.etag;
      }

      try {
        const fetchResult = await extractFetchResultPayload(
          await config.fetcher({
            entry: existingEntry,
            headers: requestHeaders,
            reason,
          }),
          config,
          existingEntry,
        );

        if (fetchResult?.notModified && existingEntry) {
          const revalidatedEntry = await write(config.module, existingEntry.data, {
            ...scopedOptions,
            savedAt: Date.now(),
            version: existingEntry.version,
            etag: fetchResult.etag || existingEntry.etag,
            revision:
              fetchResult.revision ||
              existingEntry.revision ||
              manifestState.revisions?.[resolvePolicy(config.module, scopedOptions, existingEntry).revisionDomain],
            broadcast: false,
          });
          emitChange("revalidate", config.module, revalidatedEntry, {
            ...scopedOptions,
            source: "local",
          });
          incrementMetric("revalidate304");
          return {
            data: revalidatedEntry.data,
            entry: revalidatedEntry,
            fromCache: true,
            stale: false,
          };
        }

        const nextRevision =
          fetchResult?.revision ||
          manifestState.revisions?.[
            resolvePolicy(config.module, scopedOptions, existingEntry).revisionDomain
          ] ||
          existingEntry?.revision ||
          null;
        const nextEntry = await write(config.module, fetchResult?.data ?? null, {
          ...scopedOptions,
          version: fetchResult?.version,
          etag: fetchResult?.etag,
          revision: nextRevision,
        });
        incrementMetric(reason === "refresh" ? "revalidate200" : "miss");
        return {
          data: nextEntry.data,
          entry: nextEntry,
          fromCache: false,
          stale: false,
        };
      } catch (error) {
        if (existingEntry && isPersistedAlive(config.module, existingEntry, scopedOptions)) {
          debugWarn("[Garden Cache] Query refresh failed, serving stale cache:", error);
          return {
            data: existingEntry.data,
            entry: existingEntry,
            fromCache: true,
            stale: true,
            error,
          };
        }

        throw error;
      } finally {
        pendingQueries.delete(key);
      }
    })();

    pendingQueries.set(key, requestPromise);
    return requestPromise;
  }

  async function query(input, options = {}) {
    const config = normalizeQueryInput(input, options);
    if (!config.module) {
      return {
        data: null,
        entry: null,
        fromCache: false,
        stale: false,
      };
    }

    const scopedOptions = {
      shop: config.shop,
      customerId: config.customerId,
      maxAgeMs: config.freshForMs ?? config.maxAgeMs,
      persistForMs: config.persistForMs,
      revisionDomain: config.revisionDomain,
      tags: config.tags,
      domain: config.domain,
    };
    const existingEntry = await readEntry(config.module, scopedOptions);

    if (!config.refresh && existingEntry) {
      if (isFresh(config.module, existingEntry, scopedOptions)) {
        incrementMetric("hit");
        return {
          data: existingEntry.data,
          entry: existingEntry,
          fromCache: true,
          stale: false,
        };
      }

      if (isPersistedAlive(config.module, existingEntry, scopedOptions)) {
        incrementMetric("staleHit");
        if (config.fetcher && config.background !== false) {
          void refreshQuery(config, existingEntry, "refresh");
        }
        return {
          data: existingEntry.data,
          entry: existingEntry,
          fromCache: true,
          stale: true,
        };
      }
    }

    return refreshQuery(config, existingEntry, config.refresh ? "refresh" : "load");
  }

  async function prefetch(entries, options = {}) {
    const list = Array.isArray(entries) ? entries : [entries];
    return Promise.all(
      list.filter(Boolean).map((entry) =>
        query(entry, {
          ...options,
          background: false,
        }),
      ),
    );
  }

  async function mutate(input, options = {}) {
    const config = normalizeQueryInput(input, options);
    if (!config.module || typeof config.mutation !== "function") {
      throw new Error("Garden cache mutate requires a module and mutation function.");
    }

    const scopedOptions = {
      shop: config.shop,
      customerId: config.customerId,
      maxAgeMs: config.freshForMs ?? config.maxAgeMs,
      persistForMs: config.persistForMs,
      revisionDomain: config.revisionDomain,
      tags: config.tags,
      domain: config.domain,
    };
    const previousEntry = await readEntry(config.module, scopedOptions);
    let optimisticEntry = null;

    if (typeof config.optimisticUpdate === "function") {
      const optimisticData = await config.optimisticUpdate(
        previousEntry?.data ?? null,
        previousEntry,
      );
      optimisticEntry = await write(config.module, optimisticData, {
        ...scopedOptions,
      });
      incrementMetric("optimisticWrite");
    }

    try {
      const mutationResult = await extractFetchResultPayload(
        await config.mutation({
          entry: previousEntry,
          optimisticEntry,
        }),
        config,
        optimisticEntry || previousEntry,
      );

      if (mutationResult?.notModified && (optimisticEntry || previousEntry)) {
        return {
          data: (optimisticEntry || previousEntry).data,
          entry: optimisticEntry || previousEntry,
          fromCache: Boolean(optimisticEntry || previousEntry),
          stale: false,
        };
      }

      if (typeof mutationResult?.data !== "undefined") {
        const nextEntry = await write(config.module, mutationResult.data, {
          ...scopedOptions,
          etag: mutationResult.etag,
          revision: mutationResult.revision,
        });
        return {
          data: nextEntry.data,
          entry: nextEntry,
          fromCache: false,
          stale: false,
        };
      }

      if (Array.isArray(config.invalidate)) {
        await invalidate(config.invalidate, scopedOptions);
      } else if (config.invalidate) {
        await invalidate(config.invalidate, scopedOptions);
      }

      if (config.invalidateTags) {
        await invalidateTags(config.invalidateTags, scopedOptions);
      }

      return {
        data: optimisticEntry?.data ?? previousEntry?.data ?? null,
        entry: optimisticEntry || previousEntry,
        fromCache: Boolean(optimisticEntry || previousEntry),
        stale: false,
      };
    } catch (error) {
      if (previousEntry) {
        await write(config.module, previousEntry.data, {
          ...scopedOptions,
          version: previousEntry.version,
          etag: previousEntry.etag,
          revision: previousEntry.revision,
          broadcast: false,
        });
        emitChange("rollback", config.module, previousEntry, {
          ...scopedOptions,
          source: "local",
        });
        incrementMetric("rollback");
      } else {
        await invalidate(config.module, {
          ...scopedOptions,
          broadcast: false,
        });
      }

      throw error;
    }
  }

  function ensureBroadcastChannel() {
    if (broadcastChannel || typeof window.BroadcastChannel !== "function") {
      return broadcastChannel;
    }

    try {
      broadcastChannel = new window.BroadcastChannel(BROADCAST_CHANNEL_NAME);
      broadcastChannel.addEventListener("message", (event) => {
        void applyRemoteMutation(event?.data || null);
      });
    } catch (error) {
      console.warn("[Garden Cache] BroadcastChannel unavailable:", error);
      broadcastChannel = null;
    }

    return broadcastChannel;
  }

  function createBroadcastMutationId() {
    return `${broadcastSourceId}:${Date.now().toString(36)}:${Math.random()
      .toString(36)
      .slice(2, 10)}`;
  }

  function normalizeBroadcastMutationId(payload) {
    if (!payload || typeof payload !== "object") {
      return null;
    }

    if (typeof payload.mutationId === "string" && payload.mutationId) {
      return payload.mutationId;
    }

    if (payload.sourceId && payload.occurredAt && payload.key) {
      return [
        payload.sourceId,
        payload.occurredAt,
        payload.action || "write",
        payload.key,
      ].join(":");
    }

    return null;
  }

  function markBroadcastMutationSeen(payload) {
    const mutationId = normalizeBroadcastMutationId(payload);
    if (!mutationId) {
      return false;
    }

    const now = Date.now();
    seenBroadcastMutations.forEach((expiresAt, key) => {
      if (expiresAt <= now) {
        seenBroadcastMutations.delete(key);
      }
    });

    if (seenBroadcastMutations.has(mutationId)) {
      return true;
    }

    seenBroadcastMutations.set(mutationId, now + BROADCAST_SEEN_TTL_MS);
    while (seenBroadcastMutations.size > BROADCAST_SEEN_MAX) {
      const oldestKey = seenBroadcastMutations.keys().next().value;
      if (!oldestKey) break;
      seenBroadcastMutations.delete(oldestKey);
    }

    return false;
  }

  function broadcastCacheMutation(payload) {
    if (!payload || payload.source !== "local") {
      return;
    }

    const channel = ensureBroadcastChannel();
    const message = {
      ...payload,
      mutationId: createBroadcastMutationId(),
      sourceId: broadcastSourceId,
      occurredAt: Date.now(),
    };

    if (channel) {
      try {
        channel.postMessage(message);
        return;
      } catch (error) {
        console.warn("[Garden Cache] BroadcastChannel post failed:", error);
      }
    }

    try {
      window.localStorage.setItem(BROADCAST_STORAGE_KEY, JSON.stringify(message));
      window.localStorage.removeItem(BROADCAST_STORAGE_KEY);
    } catch {
      // Ignore storage failures.
    }
  }

  function queueRemoteMutation(payload) {
    const key = String(payload.key);
    pendingRemoteMutations.set(key, payload);

    if (remoteMutationFlushTimer !== null) {
      return;
    }

    remoteMutationFlushTimer = window.setTimeout(() => {
      remoteMutationFlushTimer = null;
      const mutations = Array.from(pendingRemoteMutations.values());
      pendingRemoteMutations.clear();
      mutations.forEach((mutation) => {
        void persistRemoteMutation(mutation);
      });
    }, REMOTE_MUTATION_BATCH_MS);
  }

  async function persistRemoteMutation(payload) {
    const key = String(payload.key);
    const entry = parseEntry(payload.entry);
    if (payload.action === "invalidate" || !entry) {
      rememberEntry(key, null);
      removeMirrorByKey(key);
      const storage = await getStorage();
      if (storage) {
        try {
          await storage.removeItem(key);
        } catch {
          // Ignore remote removal failures.
        }
      }
      incrementMetric("broadcastInvalidate");
      emitChange("invalidate", payload.module || moduleFromKey(key), null, {
        shop: payload.shop,
        customerId: payload.customerId,
        source: "remote",
      });
      return;
    }

    const currentEntry = memoryEntries.get(key) || null;
    if (entryMatchesKnownContent(key, entry, currentEntry)) {
      const nextEntry = mergeRemoteFreshness(currentEntry, entry);
      if (nextEntry && nextEntry !== currentEntry) {
        rememberEntry(key, nextEntry);
      }
      return;
    }

    rememberEntry(key, entry);
    writeMirrorByKey(key, entry);
    const storage = await getStorage();
    if (storage) {
      try {
        await storage.setItem(key, entry);
      } catch {
        // Ignore remote persistence failures.
      }
    }

    emitChange(payload.action || "write", payload.module || moduleFromKey(key), entry, {
      shop: payload.shop,
      customerId: payload.customerId,
      source: "remote",
    });
  }

  async function applyRemoteMutation(payload) {
    if (!payload || payload.sourceId === broadcastSourceId || !payload.key) {
      return;
    }
    if (markBroadcastMutationSeen(payload)) {
      return;
    }

    queueRemoteMutation(payload);
  }

  function buildManifestScope(options = {}) {
    const customerId = resolveCustomerId(options);
    if (!customerId || customerId === "anonymous") {
      return null;
    }

    return {
      shop: resolveShop(options),
      customerId,
    };
  }

  async function invalidateDomainsForManifest(domains, options = {}) {
    const targets = uniqueArray(
      (Array.isArray(domains) ? domains : [domains])
        .map((value) => String(value || "").trim())
        .filter(Boolean),
    );
    if (!targets.length) {
      return;
    }

    const entries = await collectEntriesByPredicate((_key, entry) => {
      const entryDomain =
        entry?.revisionDomain || entry?.domain || inferDomainFromModule(moduleFromKey(_key, options));
      return targets.includes(entryDomain);
    }, options);
    const storage = await getStorage();

    for (const [key] of entries) {
      rememberEntry(key, null);
      removeMirrorByKey(key);
      if (storage) {
        try {
          await storage.removeItem(key);
        } catch {
          // Ignore storage removal failures.
        }
      }

      emitChange("invalidate", moduleFromKey(key, options), null, {
        ...options,
        source: "manifest",
      });
    }
  }

  async function refreshManifest(options = {}) {
    const scope = buildManifestScope(options);
    if (!scope) {
      return null;
    }
    const scopeKey = `${scope.shop}:${scope.customerId}`;
    const checkedAt = Date.now();
    if (
      !options.force &&
      manifestState.scope === scopeKey &&
      manifestState.checkedAt &&
      checkedAt - manifestState.checkedAt < MANIFEST_REFRESH_MIN_INTERVAL_MS
    ) {
      return manifestState.revisions;
    }

    if (manifestRefreshPromise) {
      return manifestRefreshPromise;
    }

    manifestRefreshPromise = (async () => {
      const headers = {
        Accept: "application/json",
      };
      if (
        manifestState.scope === scopeKey &&
        typeof manifestState.etag === "string" &&
        manifestState.etag
      ) {
        headers["If-None-Match"] = manifestState.etag;
      }

      manifestState = {
        ...manifestState,
        checkedAt,
        scope: scopeKey,
      };

      const response = await fetch(MANIFEST_ENDPOINT, {
        credentials: "same-origin",
        headers,
      });

      if (response.status === 304) {
        manifestState = {
          ...manifestState,
          checkedAt: Date.now(),
          scope: scopeKey,
        };
        return manifestState.revisions;
      }

      if (!response.ok) {
        throw new Error(`Revision manifest request failed (${response.status})`);
      }

      const payload = await response.json();
      const nextRevisions =
        payload && typeof payload === "object" && payload.revisions
          ? payload.revisions
          : null;
      if (!nextRevisions || typeof nextRevisions !== "object") {
        return null;
      }

      const changedDomains = [];
      if (manifestState.revisions) {
        Object.keys(nextRevisions).forEach((domain) => {
          if (manifestState.revisions?.[domain] !== nextRevisions[domain]) {
            changedDomains.push(domain);
          }
        });
      }

      manifestState = {
        checkedAt: Date.now(),
        etag: response.headers.get("ETag"),
        revisions: nextRevisions,
        scope: scopeKey,
      };

      if (changedDomains.length) {
        await invalidateDomainsForManifest(changedDomains, scope);
      }

      return nextRevisions;
    })()
      .catch((error) => {
        console.warn("[Garden Cache] Revision manifest refresh failed:", error);
        return manifestState.revisions;
      })
      .finally(() => {
        manifestRefreshPromise = null;
      });

    return manifestRefreshPromise;
  }

  function scheduleManifestRefresh(reason = "focus", options = {}) {
    if (reason === "focus") {
      incrementMetric("focusManifestCheck");
    }
    if (manifestRefreshTimer) {
      window.clearTimeout(manifestRefreshTimer);
    }
    manifestRefreshTimer = window.setTimeout(() => {
      manifestRefreshTimer = null;
      void refreshManifest(options);
    }, MANIFEST_REFRESH_DEBOUNCE_MS);
  }

  function ensureManifestWatchers() {
    if (manifestWatcherBound) {
      return;
    }

    manifestWatcherBound = true;
    ensureBroadcastChannel();

    window.addEventListener("storage", (event) => {
      if (event.key !== BROADCAST_STORAGE_KEY || !event.newValue) {
        return;
      }

      try {
        void applyRemoteMutation(JSON.parse(event.newValue));
      } catch {
        // Ignore malformed broadcast payloads.
      }
    });

    window.addEventListener(
      "focus",
      () => {
        scheduleManifestRefresh("focus");
      },
      { passive: true },
    );

    window.addEventListener(
      "online",
      () => {
        scheduleManifestRefresh("online");
      },
      { passive: true },
    );

    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        scheduleManifestRefresh("visibility");
        startManifestPolling();
      } else {
        stopManifestPolling();
      }
    });

    window.addEventListener(
      "garden:auth-ready",
      () => {
        scheduleManifestRefresh("auth");
      },
      { passive: true },
    );

    startManifestPolling();
  }

  function startManifestPolling() {
    if (manifestPollTimer || typeof window === "undefined") {
      return;
    }
    if (typeof document !== "undefined" && document.visibilityState === "hidden") {
      return;
    }
    manifestPollTimer = window.setInterval(() => {
      if (typeof document !== "undefined" && document.visibilityState === "hidden") {
        return;
      }
      // No-ops via buildManifestScope when there is no logged-in garden customer.
      scheduleManifestRefresh("interval");
    }, MANIFEST_POLL_INTERVAL_MS);
  }

  function stopManifestPolling() {
    if (manifestPollTimer) {
      window.clearInterval(manifestPollTimer);
      manifestPollTimer = null;
    }
  }

  function hashString(value) {
    const input = String(value || "");
    let hash = 2166136261;
    for (let index = 0; index < input.length; index += 1) {
      hash ^= input.charCodeAt(index);
      hash +=
        (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
    }
    return Math.abs(hash >>> 0).toString(36);
  }

  function imageModule(bucket, identifier) {
    return `image:${String(bucket || "default").trim()}:${hashString(identifier)}`;
  }

  async function blobToDataUrl(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result || ""));
      reader.onerror = () => reject(new Error("Could not read image data."));
      reader.readAsDataURL(blob);
    });
  }

  function dataUrlToBlob(dataUrl) {
    const parts = String(dataUrl || "").split(",");
    if (parts.length < 2) {
      return null;
    }

    const mimeMatch = parts[0].match(/^data:([^;]+);base64$/i);
    const mimeType = mimeMatch?.[1] || "application/octet-stream";

    try {
      const binary = window.atob(parts[1]);
      const bytes = new Uint8Array(binary.length);
      for (let index = 0; index < binary.length; index += 1) {
        bytes[index] = binary.charCodeAt(index);
      }
      return new Blob([bytes], { type: mimeType });
    } catch {
      return null;
    }
  }

  async function loadImageElement(blob) {
    return new Promise((resolve, reject) => {
      const url = URL.createObjectURL(blob);
      const image = new Image();
      image.decoding = "async";
      image.onload = () => {
        URL.revokeObjectURL(url);
        resolve(image);
      };
      image.onerror = () => {
        URL.revokeObjectURL(url);
        reject(new Error("Could not decode image."));
      };
      image.src = url;
    });
  }

  async function compressImageBlob(blob, options = {}) {
    const fallbackSrc = await blobToDataUrl(blob);
    const sourceType = String(blob?.type || "").toLowerCase();

    if (
      !sourceType.startsWith("image/") ||
      sourceType === "image/svg+xml" ||
      sourceType === "image/gif" ||
      typeof document === "undefined"
    ) {
      return {
        src: fallbackSrc,
        contentType: sourceType || "application/octet-stream",
        compressed: false,
      };
    }

    try {
      const image = await loadImageElement(blob);
      const maxWidth = Math.max(Number(options.maxWidth) || 960, 1);
      const maxHeight = Math.max(Number(options.maxHeight) || 960, 1);
      const quality = Math.min(Math.max(Number(options.quality) || 0.78, 0.1), 1);
      const outputType = String(options.mimeType || "image/webp").trim() || "image/webp";
      const scale = Math.min(
        1,
        maxWidth / Math.max(image.width || 1, 1),
        maxHeight / Math.max(image.height || 1, 1),
      );
      const width = Math.max(Math.round((image.width || 1) * scale), 1);
      const height = Math.max(Math.round((image.height || 1) * scale), 1);
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const context = canvas.getContext("2d", { alpha: true });
      if (!context) {
        throw new Error("Canvas unavailable.");
      }
      context.drawImage(image, 0, 0, width, height);

      let src = canvas.toDataURL(outputType, quality);
      if (!src || src === "data:,") {
        src = fallbackSrc;
      }

      return {
        src,
        contentType: src.slice(5, src.indexOf(";")) || outputType,
        compressed: src !== fallbackSrc,
        width,
        height,
      };
    } catch {
      return {
        src: fallbackSrc,
        contentType: sourceType || "application/octet-stream",
        compressed: false,
      };
    }
  }

  function normalizeResourceUrl(value) {
    if (typeof value !== "string") {
      return "";
    }

    const trimmed = value.trim();
    if (!trimmed) {
      return "";
    }

    try {
      return new URL(trimmed, window.location.href).toString();
    } catch {
      return "";
    }
  }

  async function getImage(url, options = {}) {
    const normalizedUrl = normalizeResourceUrl(url);
    if (!normalizedUrl) {
      return null;
    }

    const module =
      typeof options.module === "string" && options.module.trim()
        ? options.module.trim()
        : imageModule(options.bucket || "default", normalizedUrl);

    if (!options.refresh) {
      const cachedEntry = await readEntry(module, options);
      if (cachedEntry && isFresh(module, cachedEntry, options)) {
        return cachedEntry.data;
      }
    }

    const resolvedUrl = new URL(normalizedUrl, window.location.href);
    const sameOrigin = resolvedUrl.origin === window.location.origin;
    const response = await fetch(resolvedUrl.toString(), {
      credentials: sameOrigin ? "same-origin" : "omit",
      mode: sameOrigin ? "same-origin" : "cors",
      headers: options.headers || {},
    });

    if (!response.ok) {
      throw new Error(`Image request failed (${response.status}).`);
    }

    const blob = await response.blob();
    const imageData = await compressImageBlob(blob, options);
    const payload = {
      ...imageData,
      originalUrl: normalizedUrl,
      fetchedAt: Date.now(),
    };
    await write(module, payload, options);
    return payload;
  }

  installAppProxyFetchCache();
  ensureManifestWatchers();

  window.MrMapleGardenCache = {
    ttl: DEFAULT_TTLS,
    policies: DEFAULT_POLICIES,
    buildKey,
    buildScopedPrefix,
    ttlFor,
    persistTtlFor,
    isFresh,
    isPersistedAlive,
    peek,
    readEntry,
    read,
    write,
    update,
    invalidate,
    invalidatePrefix,
    invalidateTags,
    registerDomain,
    subscribe,
    hydrate,
    query,
    prefetch,
    mutate,
    refreshManifest,
    imageModule,
    getImage,
    dataUrlToBlob,
  };
})();
